module.exports = __webpack_public_path__ + "static/media/about-us.2ac4c7c1.png";